var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSeekerFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 91,
    viewBox: "0 0 225 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_3800_123503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.844 66.0649C171.018 71.4551 131.491 79.0966 130.933 77.5636C130.376 76.0307 167.196 64.4118 182.022 59.0217C196.848 53.6315 219.84 49.453 220.397 50.9859C220.954 52.5188 200.669 60.6748 185.844 66.0649Z",
    fill: "url(#paint0_linear_3800_123503)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.3169 77.1432C80.424 72.366 84.675 68.4404 89.6841 65.7229C94.6933 63.0054 100.302 61.582 106.001 61.582C111.699 61.582 117.308 63.0054 122.317 65.7229C127.326 68.4404 131.577 72.366 134.684 77.1432",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106 53.2973C115.163 53.2973 122.59 44.2449 122.59 33.0783C122.59 21.9117 115.163 12.8594 106 12.8594C96.838 12.8594 89.4104 21.9117 89.4104 33.0783C89.4104 44.2449 96.838 53.2973 106 53.2973Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3800_123503",
    x: 126.427,
    y: 46.1641,
    width: 98.481,
    height: 36.0977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.25,
    result: "effect1_foregroundBlur_3800_123503"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3800_123503",
    x1: 187.015,
    y1: 54.448,
    x2: 167.102,
    y2: 38.4191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSeekerFound);
export default __webpack_public_path__ + "static/media/no-seeker-found.54d611d46656dd093c3cd6d2cd2d5c8a.svg";
export { ForwardRef as ReactComponent };